import { useAuth } from "@flaminem/authentication";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";

import Logout from "src/core/assets/images/icons/logout.svg?react";
import Logo from "src/core/assets/images/logo.svg?react";
import { Button } from "src/core/components/ui/button";
import { useTenantPaths } from "src/core/hooks/routing/useTenantPaths";

export const ErrorHeader: React.FC = () => {
  const { t } = useTranslation();
  const { singOutRedirect } = useAuth();

  // SAFE: null si route globale (pas de tenantId dans l'URL)
  const paths = useTenantPaths();
  const navigate = useNavigate();

  // Fallback global :
  // - "/" permet de repasser par RootRedirect si l'utilisateur est auth
  const homeHref = paths?.home() ?? "/";

  const handleLogout = () => {
    navigate(homeHref);
    singOutRedirect();
  };

  return (
    <div className="header-container justify-between relative">
      <Link to={homeHref}>
        <Logo
          onClick={() => {
            navigate(homeHref);
          }}
          className="cursor-pointer"
        />
      </Link>

      <div className="relative z-50"></div>
      <Button
        type="button"
        variant="linkDestructive"
        size="small"
        onClick={handleLogout}
        className="mr-[40px]"
      >
        <Logout />
        {t("logout")}
      </Button>
    </div>
  );
};
